import { AccountStatementOperationData } from "./accountStatementOperationData";
import { parseDate } from "../utilities/parseHelper";
import { DateType } from "./types/index";

/**
 *  Класс данных по выписке счёта.
 */
export class AccountStatementData {
  /**
   * Список операции в выписке счёта.
   */
  public Operations: Array<AccountStatementOperationData> = [];

  /**
   * Идентификатор счёта.
   */
  public ContractId: number = -1;

  /**
   * Желаемое количество выборки операций счёта.
   */
  public Take: number = 0;

  /**
   * Количество пропущенных операций не занесённых в выписку счёта.
   * начиная с '0' элемента.
   */
  public Skip: number = 0;

  /**
   * Тип сортировки.
   */
  public SortType: number = 0;

  /**
   * Общее количество операций в выписке счёта.
   */
  public Size: number = 0;

  /**
   * Дата первой совершённой операции в счёте.
   */
  public DateFrom: DateType = null;

  /**
   * Дата последней совершённой операции в счёте.
   */
  public DateTo: DateType = null;

  /**
   * Остатока на начало выписки.
   */
  public BeginRest: number = 0;

  /**
   * Остаток на конец выписки.
   */
  public EndRest: number = 0;

  /**
   * Валюта
   */
  public Currency: string = "";

  /**
   * Конструктор с загрузкой данных с сервера.
   * @param src Источник данных.
   */
  constructor(src: any = null) {
    if (src) {
      const jsi = src.SystemInfo.Data.Properties;
      this.Currency = src.Data.Properties.currencyCharCode ?? "";
      this.ContractId = jsi.contractId ?? -1;
      this.Take = jsi.take ?? 0;
      this.Skip = jsi.skip ?? 0;
      this.SortType = jsi.sortType ?? 0;
      this.Size = jsi.size ?? 0;
      this.DateFrom = parseDate(jsi.dateFrom);
      this.DateTo = parseDate(jsi.dateTo);
      this.BeginRest = jsi.beginRest ?? 0;
      this.EndRest = jsi.endRest ?? 0;

      // реверсия суммы, т.к. с сервера приходят противоположные значения.
      // this.BeginRest *= -1;
      // this.EndRest *= -1;

      const jd = src.Data.InnerData.Data;

      for (const i in jd) {
        this.Operations.push(
          new AccountStatementOperationData(jd[i].Properties, jd[i].InnerData?.Data?.Details?.Properties)
        );
      }
    }
  }
}
